<template>
  <div>
    <b-container fluid="lg">
      <b-row class="w-100">
        <b-col cols="lg">
          <carousel-section :images="content.carouselImages"/>
        </b-col>
        <b-col cols="lg">
          <section-benefits :content="content"/>
          <b-row>
            <b-col class="py-5 text-center">
              <b-button class="button-video" @click.stop="openVideo">
                {{ content.button.description }}
                <img :alt="content.button.alt" class="ml-2"
                     :src="getImagePath(content.button.iconSrc)"/>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <video-demonstration-modal :video-name="content.modalVideoName" ref="videoModal"/>
  </div>
</template>

<script>
import VideoDemonstrationModal from '@/components/modals/VideoDemonstrationModal.vue';
import SectionBenefits from '@/components/home/SectionBenefits.vue';
import { getImageSrc } from '@/utils/assets';
import CarouselSection from '@/components/home/CarouselSection.vue';

export default {
  name: 'SecondSection',
  components: { CarouselSection, SectionBenefits, VideoDemonstrationModal },
  props: {
    content: Object,
  },
  data() {
    return {};
  },
  methods: {
    openVideo() {
      this.$refs.videoModal.videoShow = true;
    },
    getImagePath(imageName) {
      return getImageSrc(imageName);
    },
  },
};
</script>

<style scoped lang="scss">
.button-video {
  background-color: $brandPrimaryColor;
  color: $homePrimaryColor;
  padding: 12px 20px;
  border: none;
  border-radius: 25px;
  & img {
      height: 25px;
      width: 25px;
    }
  &:hover {
    opacity: 85%;
  }
}
</style>
